export default __webpack_public_path__ + "static/media/detail_bigger.0784a485.mp4";